<template>
    <iframe
        :src="reportslug"
        @load="onIFrameLoad"
        ref="theframe"
        style="border: 0; position: absolute; height: 100%; width: 100%; left: 0; top: 0;" />
</template>

<script>
import config from "../config";
import axios from "axios"

export default {
    name: "Report",
    data: () => ({
        iframeloaded: false,
        default_filters: [],
    }),
    computed: {
        clientId() 
        {
            let users_client_id = this.$store.state.auth.profile["custom:client_id"];
            let client_id;

            if (users_client_id == "999" && this.$store.state.portalsettings.client) 
            {
                // qgistix user w/999, and there is a client in the app setting, we use it
                client_id = String(this.$store.state.portalsettings.client.client_id);
            } // no selected client for QGistix 999 user, or a client who can only be their own client_id
            else 
            {
                client_id = users_client_id;
            }
            return client_id;
        },
        reportslug() 
        {
            if (this.$store.state.auth.isAuthenticated) 
            {
                let qgcontext = {
                    qg_client_id: this.clientId,
                    qg_role: this.$store.state.auth.profile["custom:role"],
                    qg_program: this.$store.state.portalsettings.program.value,
                };
                let params = {
                    standalone: "true",
                    qgcontext: encodeURI(JSON.stringify(qgcontext)),
                };

                // some dashboards set a default time range
                let default_filter = this.default_filters.find(f => f.slug == this.$route.params.reportslug)
                if (default_filter)
                {
                    // console.log("default_filter: " + JSON.stringify(default_filter.filter))
                    params.preselect_filters = encodeURI(JSON.stringify(default_filter.filter))
                }

                var query_string = Object.keys(params)
                    .map(key => key + "=" + params[key])
                    .join("&");

                return `https://bi.qgistix.com/superset/dashboard/${this.$route.params.reportslug}/?${query_string}`;

                // enable this line instead when using superset in dev mode:
                // return `https://bi.qgistix.com:9000/superset/dashboard/${this.$route.params.reportslug}/?${query_string}`;
            }
            return "";
        },
    },
    methods: {
        onIFrameLoad(e) 
        {
            this.iframeloaded = true;
        },
    },

    created() 
    {
    
        let result = axios.get(config.QDS + "calendars/" + this.clientId, { headers: { Authorization: this.$store.state.auth.idToken } })
            .then((result) =>
            {
                // console.log(JSON.stringify(result.data))
                let calendars = result.data

                // Load the default filters
                this.default_filters.push({ slug: "productivity_sorters", filter: { "26": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "productivity_testers", filter: { "22": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "completed_shipments", filter: { "16": { __time_range: "Current Month" } } })
                this.default_filters.push({ slug: "productivity_refurbishers", filter: { "26": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "productivity_cleaners", filter: { "26": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "productivity_final_qc", filter: { "26": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "productivity_all_catalogers", filter: { "26": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "productivity_process_steps", filter: { "40": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "productivity_clock_in_out_report", filter: { "26": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "shipping_completed_shipments", filter: { "55": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "shipping_open_orders", filter: { "26": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "receiving_show_all_shipments", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "receiving_rev_advance_shipment_notifications", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "receiving_rev_show_all_shipments", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "receiving_rev_details", filter: { "60": { __time_range: "Previous Week" } } })
                this.default_filters.push({ slug: "receiving_rev_branch_summary", filter: { "60": { __time_range: "Previous Week" } } })
                this.default_filters.push({ slug: "receiving_rev_branch_compliance", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "pipeline_snapshot", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "pipeline_cumulative", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "testing_yield_summary_by_age", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "testing_yield_summary_report", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "testing_detail_report", filter: { "60": { __time_range: "Current Week" } } })
                this.default_filters.push({
                    slug: "reverse_logistics_warranty_return_program_queue",
                    filter: { "121": { week_display: calendars.slice(1,2).reduce((accum, c) => { accum.push(c.week_display.replace(" Week ", ":")); return accum }, []) } },
                })
                this.default_filters.push({ slug: "shipping_shipping", filter: { "86": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "shipping_performance", filter: { "84": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "cataloging_show_all_parts", filter: { "95": { __time_range: "Yesterday" } } })
                this.default_filters.push({ slug: "inbound_shipments", filter: { "97": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "inbound_stock_summary", filter: { "101": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "rtv_part_movement_and_transmission", filter: { "102": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "inbound_stock_details", filter: { "12": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "rma_to_manufacturer_all_active_rma", filter: { "103": { __time_range: "Last 30 days" } } })
                this.default_filters.push({ slug: "reverse_logistics_warranty_return_valuation", filter: { "114": { __time_range: "Year to Date" } } })
                this.default_filters.push({ slug: "rma_to_qgistix", filter: { "105": { __time_range: "Previous Week" } } })
                this.default_filters.push({ slug: "rma_to_qgistix_details", filter: { "105": { __time_range: "Previous Week" } } })
                this.default_filters.push({ slug: "cataloging_branch_compliance", filter: { "107": { __time_range: "Previous Week" } } })
                this.default_filters.push({ slug: "calaloging_part_detail_all_parts", filter: { "109": { __time_range: "Previous Week" } } })
                this.default_filters.push({ slug: "reverse_logistics_warranty_return_valuation_mfg", filter: { "114": { __time_range: "Previous Month" } } })
                this.default_filters.push({
                    slug: "cataloging_reverse_logistics_cycle_time",
                    filter: { "121": { week_display: calendars.slice(1,14).reduce((accum, c) => { accum.push(c.week_display.replace(" Week ", ":")); return accum }, []) } },
                })
                this.default_filters.push({
                    slug: "reverse_logistics_disposition_summary",
                    filter: { "121": { week_display: calendars.slice(1,2).reduce((accum, c) => { accum.push(c.week_display.replace(" Week ", ":")); return accum }, []) } },
                }),
                this.default_filters.push({ slug: "rev_part_details", filter: { "125": { __time_range: "Previous Week" } } })
                this.default_filters.push({
                    slug: "receiving_summary",
                    filter: { "121": { week_display: calendars.slice(1,2).reduce((accum, c) => { accum.push(c.week_display.replace(" Week ", ":")); return accum }, []) } },
                })
                this.default_filters.push({
                    slug: "fwd_billing_details_outbound",
                    filter: { "121": { week_display: calendars.slice(1,2).reduce((accum, c) => { accum.push(c.week_display.replace(" Week ", ":")); return accum }, []) } },
                }),
                this.default_filters.push({ slug: "shredded_hdd_details", filter: { "137": { __time_range: "Previous Week" } } }),
                this.default_filters.push({ slug: "cdr_rmasummary", filter: { "140": { __time_range: "Current Week" } } })
                this.default_filters.push({ slug: "cdr_closedrmasummary", filter: { "121": { week_display: calendars.slice(1,2).reduce((accum, c) => { accum.push(c.week_display.replace(" Week ", ":")); return accum }, []) } } })
                this.default_filters.push({ slug: "cdr_closedrmadetail", filter: { "121": { __time_range: "Current Week" } } })
            },
            (error) =>
            {
                console.log(error);
            })

    },
};
</script>
  